var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadVideoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.66667 18.6667C2.66667 20.1394 3.86057 21.3333 5.33333 21.3333L18.6667 21.3333C20.1394 21.3333 21.3333 20.1394 21.3333 18.6667L21.3333 17.3333C21.3333 16.597 21.9303 16 22.6667 16C23.403 16 24 16.597 24 17.3333L24 18.6667C24 21.6122 21.6122 24 18.6667 24L5.33333 24C2.38782 24 -1.04375e-07 21.6122 -2.33127e-07 18.6667L-2.91409e-07 17.3333C-3.23597e-07 16.597 0.596953 16 1.33333 16C2.06971 16 2.66667 16.597 2.66667 17.3333L2.66667 18.6667ZM5.72386 11.0572C6.24456 10.5365 7.08878 10.5365 7.60948 11.0572L10.6667 14.1144L10.6667 1.33333C10.6667 0.596956 11.2636 1.415e-06 12 1.38281e-06C12.7364 1.35062e-06 13.3333 0.596956 13.3333 1.33333L13.3333 14.1144L16.3905 11.0572C16.9112 10.5365 17.7554 10.5365 18.2761 11.0572C18.7968 11.5779 18.7968 12.4221 18.2761 12.9428L12.9428 18.2761C12.4221 18.7968 11.5779 18.7968 11.0572 18.2761L5.72386 12.9428C5.20316 12.4221 5.20316 11.5779 5.72386 11.0572Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadVideoIcon);
export default __webpack_public_path__ + "static/media/DownloadVideoIcon.3a1afeb034da60a40bc9ecfb62d41cec.svg";
export { ForwardRef as ReactComponent };